import React, { useState } from 'react';
import { Layout, Menu, Dropdown, Avatar, Tag, Space, Typography, Grid, Drawer, Button } from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  TeamOutlined,
  MenuOutlined,
  AuditOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';

const { Header, Content } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

/**
 * Panel del fiscal-admin.
 *
 * Sigue el patrón de AdminLayout —rutas fijas y guard propio— y NO el mecanismo
 * client_access → screens del panel de usuario: ese es exclusivo del cliente y
 * además es fail-open (concede cuando allowed_screens viene ausente).
 */
const FiscalLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  // La cartera es el punto de entrada único: la gestión fiscal se abre sobre
  // el contribuyente seleccionado, no como sección aparte.
  const menuItems = [
    {
      key: '/fiscal/cartera',
      icon: <TeamOutlined />,
      label: 'Mi cartera',
      onClick: () => {
        navigate('/fiscal/cartera');
        setDrawerVisible(false);
      },
    },
  ];

  const userMenuItems = [
    {
      key: 'profile',
      icon: <AuditOutlined />,
      label: user?.email,
      disabled: true,
    },
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Cerrar Sesión',
      onClick: handleLogout,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        style={{
          backgroundColor: '#003a4d',
          padding: screens.md ? '0 24px' : '0 12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          width: '100%',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Text
            style={{
              color: 'white',
              fontSize: screens.md ? '18px' : '16px',
              fontWeight: 'bold',
              margin: 0,
              marginRight: '24px',
              whiteSpace: 'nowrap',
            }}
          >
            {screens.md ? 'Mi Factura - Fiscal' : 'Fiscal'}
          </Text>
        </div>

        {screens.md ? (
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              flex: 1,
              minWidth: 0,
            }}
          />
        ) : (
          <Button
            type="text"
            icon={<MenuOutlined style={{ color: 'white' }} />}
            onClick={() => setDrawerVisible(true)}
          />
        )}

        <Space>
          <Tag color="cyan">fiscal-admin</Tag>
          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
            <Avatar style={{ backgroundColor: '#13c2c2', cursor: 'pointer' }} icon={<UserOutlined />} />
          </Dropdown>
        </Space>
      </Header>

      <Drawer
        title="Fiscal"
        placement="left"
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        styles={{ body: { padding: 0 } }}
      >
        <Menu mode="inline" selectedKeys={[location.pathname]} items={menuItems} />
      </Drawer>

      <Content style={{ padding: screens.md ? '24px' : '12px' }}>
        <Outlet />
      </Content>
    </Layout>
  );
};

export default FiscalLayout;
